import React, { FC, useContext, useState } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';

import { toast } from 'react-toastify';
import { ToastMessage, BaseModal, Input, Button } from '@cokitchen/cokitchen-components';
import { UserProfileContext } from './context';
import { apiService } from 'utils/api';
import { getUserName } from 'utils/functions';
interface OweModalProps {
  show: boolean;
  onClose: (withRes?: boolean) => void;
}

interface OweModalFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  disabled: boolean;
}

const OweModalFooter: FC<OweModalFooterProps> = ({ onCancel, onConfirm, loading, disabled }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      disabled={disabled}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const OweModal: FC<OweModalProps> = ({ show, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');

  const { user } = useContext(UserProfileContext);
  const updateDebt = async () => {
    setLoading(true);
    const data = {
      owe: amount,
      reason,
      user_id: user?.id
    };
    try {
      await apiService.post('admin/user/owe', {
        data,
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Debt Updated successfully' />);
      setAmount('');
      setReason('');
      onClose(true);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const name = getUserName(user);

  return (
    <BaseModal
      isOpen={show}
      title={`Update ${name} debt`}
      titleIcon={<TitleIcon />}
      titleIconColor='info'
      onRequestClose={() => onClose()}
      footer={
        <OweModalFooter
          loading={loading}
          onCancel={() => onClose()}
          onConfirm={updateDebt}
          disabled={!amount || !reason}
        />
      }>
      <Input
        className='mb-2'
        type='number'
        label='New Amount'
        onChange={(ev) => setAmount(ev.target.value)}
        value={amount}
        placeholder='Amount'
      />
      <Input
        className='mb-2'
        label={`Reason for updating ${name}'s debt`}
        onChange={(ev) => setReason(ev.target.value)}
        value={reason}
        placeholder='User bought food on credit'
      />
    </BaseModal>
  );
};

export default OweModal;
